<template>
    <div class="container-fluid">
        <Breadcrumb title="Messages" v-bind:button-show=true button-url="messageCreate"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="input-group form-group">
                            <div class="form-group">
                                <treeselect placeholder="Search by Archive Status"
                                            :clearable=false
                                            v-model="archiveStatusSearch"
                                            :options="archiveStatusSelect"/>
                            </div>
                            <div class="form-group" v-if="isAdmin">
                                <treeselect v-model="userSearch" placeholder="Search by owner" :multiple="false"
                                            :options="userSelect"/>
                            </div>
                            <input v-model="messageSearch" type="text" class="form-control form-control-line"
                                   placeholder="Search by name">
                            <div class="input-group-append">
                                <button v-on:click="search" class="btn btn-info" type="button">Search</button>
                            </div>
                        </div>
                        <div class="form-group mx-sm-3 mb-2">
                                <span>Total:
                                    <span class="label label-info">{{totalItems}}</span>
                                </span>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="messageList.length > 0">
                                <div class="table-responsive">
                                    <table class="table">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Subject</th>
                                            <th v-if="isAdmin">Owner</th>
                                            <th v-if="showArchive">Archive</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(message, index) in messageList" :key="index">
                                            <td class="align-middle">{{message.id}}</td>
                                            <td class="align-middle">{{message.name}}</td>
                                            <td class="align-middle">{{message.subject}}</td>
                                            <td class="align-middle" v-if="isAdmin">{{message.user.username}}</td>
                                            <td class="align-middle" v-if="showArchive">{{message.archive ? moment(message.archive.toString()).format('Y-M-D') : '-'}}</td>
                                            <td class="align-middle">
                                                <router-link :to="{ name: 'messageEdit', params: { id: message.id }}"
                                                             class="btn btn-info btn-sm">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                                <button type="button" class="btn btn-success btn-sm m-l-10"
                                                        @click="openMessage(message)">
                                                    <i class="fas fa-eye"></i> Preview
                                                </button>
                                                <button type="button" class="btn btn-danger btn-sm m-l-10" v-if="!message.archive"
                                                        @click="archiveMessage(message.id)">
                                                    <i class="fa fa-minus-circle"></i> Archive
                                                </button>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <paginate v-if="pageCount > 1"
                                          v-model="page"
                                          :page-count="pageCount"
                                          :page-range="3"
                                          :margin-pages="2"
                                          :click-handler="getItems"
                                          :prev-text="'Prev'"
                                          :next-text="'Next'"
                                          :container-class="'pagination justify-content-center'"
                                          :page-class="'page-item'"
                                          :page-link-class="'page-link'"
                                          :prev-class="'page-item'"
                                          :prev-link-class="'page-link'"
                                          :next-class="'page-item'"
                                          :next-link-class="'page-link'">
                                </paginate>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Swal from 'sweetalert2';
    import MessageService from '../services/MessageService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';
    import paginateMixin from '../mixins/paginate-mixin';
    import Treeselect from '@riophae/vue-treeselect';
    import '@riophae/vue-treeselect/dist/vue-treeselect.css';
    import UserService from '../services/UserService';

    export default {
        name: 'Messages',
        components: {
            Preloader, Breadcrumb, Treeselect
        },
        mixins: [paginateMixin],
        data() {
            return {
                messageList: [],
                messageSearch: null,
                userSearch: null,
                userSelect: [],
                loading: false,
                totalItems: 0,
                page: 1,
                perPage: paginateMixin.defaultPerPage,
                isAdmin: false,
                archiveStatusSearch: false,
                archiveStatusSelect: [
                    {id: 'all', label: 'All'},
                    {id: true, label: 'Archive'},
                    {id: false, label: 'Current'}
                ],
                showArchive: false
            }
        },
        mounted() {
            this.isAdmin = this.$store.getters.isAdmin;
            if (this.isAdmin) {
                UserService.getUserSelect().then(response => {
                    this.userSelect = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                });
            }
            this.getItems(this.page = 1);
        },
        methods: {
            getItems: function (pageNum) {
                this.loading = true;
                this.showArchive = this.archiveStatusSearch !== false;
                MessageService.getMessages(pageNum, this.perPage, this.messageSearch, this.userSearch, this.archiveStatusSearch).then(response => {
                    this.messageList = response.data['hydra:member'];
                    this.totalItems = response.data['hydra:totalItems'];
                    this.loading = false;
                });
            },
            search: function () {
                this.getItems(this.page = 1);
            },
            archiveMessage(id) {
                Swal({
                    title: 'Are you sure you want to move it to the archive?',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Confirm',
                    showLoaderOnConfirm: true,
                    preConfirm: () => {
                        return MessageService.archiveMessage(id).then((response) => {
                            if (response.status === 200) {
                                this.getItems(this.page);
                            }
                        }).catch(error => {
                            Swal.showValidationMessage(
                                `Failed: ${error.response.data.error[0]}`
                            );
                            return false;
                        });
                    },
                    allowOutsideClick: () => !Swal.isLoading()
                }).then((result) => {
                    if (result.value) {
                        Swal(
                            'Archived successfully!',
                            `Message has been archived.`,
                            'success'
                        )
                    }
                })
            },
            async openMessage(message) {
                await MessageService.getMessage(message.id).then(response => {
                    MessageService.getMessagePreview(response.data, null, null).then(response => {
                        if (response.status === 200) {
                            let previewWindow = window.open();
                            previewWindow.document.open();
                            previewWindow.document.write(response.data.html);
                            previewWindow.document.close();
                        }
                    });
                });
            }
        },
        computed: {
            pageCount: function () {
                return Math.ceil(this.totalItems / this.perPage);
            }
        }
    }
</script>

<style scoped>

</style>